import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAdminSession, isAuthenticatedSession } from '../../security';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
}

export default function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const location = useLocation();

  if (requireAdmin && !isAdminSession()) {
    return <Navigate to="/" replace />;
  }

  if (!isAuthenticatedSession()) {
    const redirectTo = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={`/login?redirectTo=${encodeURIComponent(redirectTo)}`} replace />;
  }

  return <>{children}</>;
}
